import React from 'react';
import * as Icons from 'lucide-react';
// const Icon = ({ icon: IconComponent, className = '', ...props }) => {
//   return <IconComponent className={className} {...props} />;
// };

// export default Icon;

const Icon = ({ iconName, className = '', ...props }) => {
  const LucideIcon = Icons[iconName]; // Look up the component by string key
  if (!LucideIcon) return null;   // Fallback if icon name is invalid
  return <LucideIcon className={className} {...props} />;
};

export default Icon;
